import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from "classnames";
import bindAll from "lodash.bindall";
import styles from "./menu-bar.css";
import qs from 'qs';
import mystuffIcon from "./icon--mystuff.png";
import AccountNav from "../../containers/account-nav";
import { FormattedMessage } from "react-intl";
import { accountMenuOpen, closeAccountMenu, openAccountMenu } from "../../reducers/menus";
import { setUser, logout } from "../../teach/reducers/teach";
import { showLoading } from "../../teach/components/loading/loading";
import ModalManager from "../../teach/components/modal/modal-manager";
import LoginRegModal from "../../teach/components/login-reg-modal/login-reg-modal";
import { Link } from "react-router-dom";
import message from "../../teach/components/message/message";
import JoinCourseModal from "../../teach/components/join-course-modal/join-course-modal";
import { getClazzCourse } from "../../teach/api/clazz-course";
import { login, me, update } from '../../teach/api/user';
import TipsModal from '../../teach/pages/accounts/tipsModal';
import renderVipModal from '../../teach/components/pay-modal/pay-modal';
import vipImg from './vip.png';

class LoginEntry extends React.PureComponent {

    constructor(props) {
        super(props);
        bindAll(this, [
            'getUser',
            'handleClickTeacher',
            'challenge',
            'becomeVip',
            'handleClickTeacherCenter'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    }

    componentDidMount() {
        this.getUser();
        document.addEventListener('keyup', (e) => {
            const loginBtn = document.getElementById('login')
            if (loginBtn) {
                if (e.keyCode == 13) {
                    loginBtn.click()
                }
            }
        })
    }

    getUser() {
        me({}, { quiet: !!this.props.username }).then(res => {
            this.props.setUser(res)
        }).then(() => {

            if (this.query.from) {
                console.log(this.props.username)
                this.becomeVip()
            }
        });
    }

    handleClick() {
        ModalManager.open(JoinCourseModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            onSetId: async (id) => {
                try {
                    const clazzCourse = await getClazzCourse({ id: id }, { showLoading: true });
                    ModalManager.pop();
                    this.props.history.push('/course?id=' + clazzCourse.course_id + '&clazz_id=' + clazzCourse.clazz_id);
                    // this.props.history.push('/teacher/class?id=' + clazzCourse.id);
                } catch (e) {

                }
            }
        });
    }

    async handleClickTeacher() {
        const { role } = this.props;
        ModalManager.open(TipsModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            onSetId: async () => {
                try {
                    let users = await update({
                        role: role == 1 ? 2 : 1,
                    });
                    this.props.setUser(users);
                    ModalManager.pop();
                    message.show(window.L('teach.user.changeSuccess'));
                    this.props.history.push('/helper');
                } catch (error) {
                    // eslint-disable-next-line no-alert
                    if (error.msg || error.data) {
                        message.show(error.msg.name || error.data);
                    } else {
                        message.show(error.toString());
                    }
                }
            },
            showLoading, role
        });

    }

    challenge() {
        // window.open('https://www.pkcode.cn/#/', '_blank')
        window.open(`${window.config.pkcodeUrl}/sign/auto-sign?api_token=${localStorage.getItem('api-token')}`)
        // const params = {
        //     'api_token': localStorage.getItem('api-token')
        // }
        // let temp_form = document.createElement("form");
        // temp_form.action = `${window.config.pkcodeUrl}/sign/auto-sign`;
        // //如需打开新窗口，form的target属性要设置为'_blank'
        // temp_form.target = "_blank";
        // temp_form.method = "post";
        // temp_form.style.display = "none";
        // //添加参数
        // for (var item in params) {
        //     var opt = document.createElement("input");
        //     opt.name = item;
        //     opt.value = params[item];
        //     temp_form.appendChild(opt);
        // }
        // document.body.appendChild(temp_form);
        // //提交数据
        // temp_form.submit();
    }

    becomeVip() {
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.redirectTo({ url: '/pages/pay/pay' });
        } else {
            const { user } = this.props
            if (!this.props.username) {
                ModalManager.open(LoginRegModal, {
                    closeAfterSubmit: true,
                    onClose: () => { },
                    setUser, showLoading
                }, 'login');
            } else {
                ModalManager.open(renderVipModal, {
                    user,
                    onClose: () => { },
                    onReload: () => this.getUser(),
                    setUser
                })
            }
        }
    }

    handleClickTeacherCenter() {
        window.open(`${window.config.baseURL}/teacher/center`, '_blank')
    }

    render() {
        const { setUser, location, role, onLogOut } = this.props;
        return (
            <div style={{ display: 'flex' }}>
                {location.pathname == '/' ? (
                    <div style={{ display: 'flex' }}>
                        <div
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable,
                                styles.mystuffButton
                            )}
                            onClick={() => this.becomeVip()}
                        >
                            <img src={vipImg} style={{ marginRight: '4px' }} />VIP会员
                        </div>
                        {/* <a
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable,
                                styles.mystuffButton
                            )}
                            href="https://pkcode.oss-cn-hangzhou.aliyuncs.com/scratch/download/XiaoAoAI_1.0.0.zip"
                            title="Windows版应用程序下载"
                        >
                            {window.L('scratch.app.download')}
                        </a> */}
                        <Link to="/helper">
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.hoverable,
                                    styles.mystuffButton
                                )}
                            >
                                {window.L('teach.user.helper')}
                            </div>
                        </Link>
                    </div>
                ) : null}
                {this.props.username ? (
                    // ************ user is logged in ************
                    <div className={styles.menuBarItem}>
                        {/* {location.pathname == '/' ? (
                            <Link to="/helper">
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        styles.mystuffButton
                                    )}
                                >
                                    {window.L('teach.user.helper')}
                                </div>
                            </Link>
                        ) : null} */}
                        {location.pathname == '/' && role == 1 ? (
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.hoverable,
                                    styles.mystuffButton
                                )}
                                onClick={this.handleClickTeacher}
                            >
                                {window.L('teach.user.teacher')}
                            </div>
                        ) : null}
                        {/* {location.pathname == '/' ? (
                            <div
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable,
                                styles.mystuffButton
                            )}
                            onClick={this.handleClickTeacherCenter}
                        >
                            教学中心
                        </div>
                        ) : null} */}
                        {location.pathname == '/' ? (
                            <Link to="/myclasses">
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        styles.mystuffButton
                                    )}
                                >
                                    {window.L('teach.user.myclass')}
                                </div>
                            </Link>
                        ) : null}
                        {/*location.pathname == '/' ? (
                        <Link to="/teacher/classes">
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.hoverable,
                                    styles.mystuffButton
                                )}
                            >
                                {window.L('teach.user.teacher')}
                            </div>
                        </Link>
                    ) : null*/}
                        {/*location.pathname == '/' ? (
                        <div
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable,
                                styles.mystuffButton
                            )}
                            onClick={()=>this.handleClick()}
                        >
                            {window.L('teach.course.joinCourse')}
                        </div>
                    ) : null*/}
                        <Link to="/projects/mine">
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.hoverable,
                                    styles.mystuffButton
                                )}
                            >
                                {location.pathname == '/' ? (
                                    window.L('teach.project.myProjects')
                                ) : (
                                    <img
                                        className={styles.mystuffIcon}
                                        src={mystuffIcon}
                                    />
                                )}

                            </div>
                        </Link>
                        <Link to="/projects/myshare">
                            {location.pathname == '/' ? (
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        styles.mystuffButton
                                    )}
                                >
                                    我的分享
                                </div>
                            ) : (null)}
                        </Link>
                        {location.pathname == '/' ? (
                            <div
                                className={classNames(
                                    styles.menuBarItem,
                                    styles.hoverable,
                                    styles.mystuffButton
                                )}
                                onClick={() => this.challenge()}
                            >
                                编程挑战
                            </div>
                        ) : null}
                        <AccountNav
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable,
                                { [styles.active]: this.props.accountMenuOpen }
                            )}
                            isOpen={this.props.accountMenuOpen}
                            isRtl={this.props.isRtl}
                            menuBarMenuClassName={classNames(styles.menuBarMenu)}
                            onClick={this.props.onClickAccount}
                            onClose={this.props.onRequestCloseAccount}
                            onLogOut={() => {
                                onLogOut();
                                // this.getCourse();
                            }}
                            onJoinCourse={() => this.handleClick()}
                            isHome={location.pathname === '/' ? true : false}
                        />
                    </div>
                ) : (
                    // ********* user not logged in, but a session exists
                    // ********* so they can choose to log in
                    <div className={styles.menuBarItem}>
                        {/* {this.props.onOpenRegistration && <div
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable
                            )}
                            key="join"
                            onMouseUp={this.props.onOpenRegistration}
                        >
                            <FormattedMessage
                                defaultMessage="Join Scratch"
                                description="Link for creating a Scratch account"
                                id="gui.menuBar.joinScratch"
                            />
                        </div>
                        } */}
                        <div
                            id="__login-btn"
                            className={classNames(
                                styles.menuBarItem,
                                styles.hoverable
                            )}
                            key="login"
                            onMouseUp={() => {
                                if (window.__wxjs_environment === 'miniprogram') {
                                    wx.miniProgram.redirectTo({ url: '/pages/logicalDeal/logicalDeal' });
                                } else {
                                    ModalManager.open(LoginRegModal, {
                                        closeAfterSubmit: true,
                                        onClose: () => { },
                                        setUser, showLoading
                                    }, 'login');
                                }

                            }}
                        >
                            <FormattedMessage
                                defaultMessage="Sign in"
                                description="Link for signing in to your Scratch account"
                                id="gui.menuBar.signIn"
                            />
                        </div>
                    </div>
                )}
            </div>
        )
    }
};

const mapStateToProps = state => ({
    username: state.teach.user ? state.teach.user.name : null,
    accountMenuOpen: accountMenuOpen(state),
    isRtl: state.locales.isRtl,
    role: state.teach.user ? state.teach.user.role : null,
    user: state.teach.user
});

const mapDispatchToProps = dispatch => ({
    onClickAccount: () => dispatch(openAccountMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onLogOut: () => dispatch(logout()),

    setUser: user => dispatch(setUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginEntry));
